/**
 * Horizontal edge/side of a timeline element (drag-resize handles, offscreen
 * edge indicators). Shared by the filter range bar and its edge indicator.
 */
export enum EdgeSide {
  Left = 'left',
  Right = 'right',
}
